"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SnackbarContent = void 0;
var _react = _interopRequireDefault(require("react"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _CheckCircle = _interopRequireDefault(require("@material-ui/icons/CheckCircle"));
var _Error = _interopRequireDefault(require("@material-ui/icons/Error"));
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
var _Info = _interopRequireDefault(require("@material-ui/icons/Info"));
var _SmsFailed = _interopRequireDefault(require("@material-ui/icons/SmsFailed"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _Snackbar = _interopRequireDefault(require("@material-ui/core/Snackbar"));
var _SnackbarContent = _interopRequireDefault(require("@material-ui/core/SnackbarContent"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _styles = require("@material-ui/core/styles");
var _clsx = _interopRequireDefault(require("clsx"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _excluded = ["title", "message", "onClose", "action", "type", "className"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Snackbar = function Snackbar(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    message = _ref.message,
    title = _ref.title,
    action = _ref.action,
    type = _ref.type;
  var handleClose = function handleClose(event, reason) {
    if (reason === 'clickaway') return;
    onClose(event);
  };
  return /*#__PURE__*/_react["default"].createElement(_Snackbar["default"], {
    open: open,
    onClose: handleClose,
    autoHideDuration: 6000
  }, /*#__PURE__*/_react["default"].createElement(SnackbarContent, {
    onClose: handleClose,
    title: title,
    message: message,
    action: action,
    type: type
  }));
};
Snackbar.propTypes = {
  onClose: _propTypes["default"].func.isRequired,
  open: _propTypes["default"].bool.isRequired,
  title: _propTypes["default"].string,
  message: _propTypes["default"].string,
  action: _propTypes["default"].shape({
    text: _propTypes["default"].string,
    onClick: _propTypes["default"].func
  }),
  type: _propTypes["default"].oneOf(['error', 'success', 'warning', 'informative'])
};
Snackbar.defaultProps = {
  title: undefined,
  message: undefined,
  action: null,
  type: undefined
};
var _default = exports["default"] = Snackbar;
var variantIcon = {
  success: _CheckCircle["default"],
  warning: _Info["default"],
  informative: _SmsFailed["default"],
  error: _Error["default"]
};
var useWrapperStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      display: 'flex',
      alignItems: 'flex-start',
      boxShadow: 'none',
      borderRadius: 8,
      padding: theme.spacing(1)
    },
    success: {
      color: theme.palette.green.dark,
      backgroundColor: theme.palette.green.light,
      '& $icon': {
        color: theme.palette.green.main
      }
    },
    error: {
      color: theme.palette.red.dark,
      backgroundColor: theme.palette.red.light,
      '& $icon': {
        color: theme.palette.red.main
      }
    },
    warning: {
      color: theme.palette.yellow.dark,
      backgroundColor: theme.palette.yellow.light,
      '& $icon': {
        color: theme.palette.yellow.main
      }
    },
    informative: {
      color: theme.palette.blue.dark,
      backgroundColor: theme.palette.blue.light,
      '& $icon': {
        color: theme.palette.blue.main
      }
    },
    action: {
      margin: 0,
      padding: 0
    },
    closeButton: {
      padding: 0
    },
    icon: {
      marginRight: theme.spacing(1.2)
    },
    messageContainer: {
      padding: 0,
      flex: 1,
      display: 'flex',
      alignItems: 'center',
      wordBreak: 'break-word'
    },
    titleWrapper: {
      display: 'flex',
      marginBottom: theme.spacing(1)
    },
    contentWrapper: {
      display: 'flex'
    },
    title: {
      fontWeight: 'bold',
      margin: 0
    },
    message: {
      margin: 0
    },
    bold: {
      fontWeight: 'bold'
    }
  };
});
var SnackbarContent = exports.SnackbarContent = function SnackbarContent(_ref2) {
  var title = _ref2.title,
    message = _ref2.message,
    onClose = _ref2.onClose,
    action = _ref2.action,
    type = _ref2.type,
    className = _ref2.className,
    other = _objectWithoutProperties(_ref2, _excluded);
  var classes = useWrapperStyles();
  var Icon = variantIcon[type];
  return /*#__PURE__*/_react["default"].createElement(_SnackbarContent["default"], _extends({
    className: (0, _clsx["default"])(classes.root, classes[type], className),
    classes: {
      message: classes.messageContainer,
      action: classes.action
    },
    message: title ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.titleWrapper
    }, /*#__PURE__*/_react["default"].createElement(Icon, {
      className: classes.icon
    }), /*#__PURE__*/_react["default"].createElement("h4", {
      className: classes.title
    }, title)), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
      variant: "body",
      className: (0, _clsx["default"])(classes.message)
    }, message)) : /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.contentWrapper
    }, /*#__PURE__*/_react["default"].createElement(Icon, {
      className: classes.icon
    }), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
      variant: "body",
      className: (0, _clsx["default"])(classes.message, classes.bold)
    }, message)),
    action: action ? /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      key: "undo",
      color: "inherit",
      size: "small",
      onClick: action.onClick
    }, action.text) : /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
      key: "close",
      "aria-label": "close",
      color: "inherit",
      onClick: onClose,
      className: classes.closeButton
    }, /*#__PURE__*/_react["default"].createElement(_Close["default"], null))
  }, other));
};
SnackbarContent.propTypes = {
  title: _propTypes["default"].string,
  message: _propTypes["default"].string,
  onClose: _propTypes["default"].func,
  action: _propTypes["default"].shape({
    text: _propTypes["default"].string,
    onClick: _propTypes["default"].func
  }),
  type: _propTypes["default"].oneOf(['error', 'success', 'warning']),
  className: _propTypes["default"].string
};
SnackbarContent.defaultProps = {
  title: undefined,
  onClose: undefined,
  message: '',
  action: null,
  type: 'success',
  className: undefined
};